module.exports = __webpack_public_path__ + "static/media/shutterstock-1015035208-1.c72e8240.png";